import Image from 'next/image';
import React, { CSSProperties } from 'react';

import { avatarStyles } from '@/ui/Avatars/Avatar';
import {
  getLiquidityProviderLogo,
  liquiditySourceAvatarRadius,
} from '@/ui/Avatars/LiquidityProviderAvatar';

import { getLiquiditySourceLabel } from '@/utils/liquidity-sources';

import { SubRoute } from '../types';

export const SankeyTooltip: React.FC<SubRoute> = React.memo(
  ({ liquiditySource, value, sourceLink }) => {
    const { root } = avatarStyles();

    // Use <Image /> instead of <LiquidityProviderImage /> because <SankeyDiagram /> renders this tooltip
    // to static markup and <LiquidityProviderImage /> stays in a loading state.
    const providerLogo = getLiquidityProviderLogo(liquiditySource) ?? 'default';
    const providerLogoSrc = `/images/liquidity-providers/${providerLogo}.png`;

    return (
      <div className="flex flex-col gap-2 min-w-[235px] p-4 rounded-[16px] bg-special-background-tooltip shadow-25">
        <div className="flex justify-between items-center">
          <div className="flex items-center gap-2">
            <div
              className={root()}
              style={{ '--avatar-border-radius': liquiditySourceAvatarRadius } as CSSProperties}
            >
              <Image
                src={providerLogoSrc}
                alt={`${liquiditySource} logo`}
                width={20}
                height={20}
                onError={(e) => {
                  e.currentTarget.src = '/images/liquidity-providers/default.png';
                }}
                className="size-5 object-cover"
              />
            </div>
            <span>{getLiquiditySourceLabel(liquiditySource)}</span>
          </div>
          <span>{value}%</span>
        </div>
        <div className="flex justify-between text-token-gray-800">
          <span>Trading pair</span>
          <span>
            {sourceLink.fromSymbol}/{sourceLink.toSymbol}
          </span>
        </div>
      </div>
    );
  },
);

SankeyTooltip.displayName = 'SankeyTooltip';
